import React, { useEffect } from "react";

import { select } from "d3-selection";

import { useChartContext } from "./ChartContext";
import {
  calculatePercents,
  totalData,
  StatusBarItemType,
  StatusBarDataItem,
} from "./helpers";
import styles from "./StatusBarChart.scss";

interface DescriptionItem extends StatusBarDataItem {
  linkUrl: string;
  linkLabel: string;
}

export default function ChartDescription() {
  const values = useChartContext();
  const state = values;
  const { svgRef, data, linkLabel, linkUrl, resize } = state;

  useEffect(() => {
    const total = totalData(data);
    const percents = calculatePercents(data, total);

    const d = percents.filter((f) => f.tag === StatusBarItemType.AT_RISK)[0];

    const statusTitle = state.statusTitle ?? "Open Goals risk status";
    const statusDescription =
      state.statusDescription ??
      `${d.percent}% or ${d.points} goals are at risk of not being completed. `;

    const item: DescriptionItem[] = [
      {
        ...d,
        linkUrl,
        linkLabel,
      },
    ];
    const svgElement = select(svgRef.current);
    const width = parseInt(svgElement.style("width"), 10);
    const config = {
      margin: { top: 10, right: 5, bottom: 20, left: 10 },
      barHeight: 23,
    };
    const { margin, barHeight } = config;

    const spacingChartTitle = 20;
    const spacingChartDescription = 6;
    const yChartTitle = barHeight + margin.top + spacingChartTitle;
    const yChartDescription = yChartTitle + spacingChartDescription;
    const w = width - margin.left - margin.right;

    const gElement = svgElement
      .select(".chart-description")
      .attr("transform", "translate(0," + margin.top + ")");

    // add title of description
    gElement
      .selectAll("text")
      .data(item)
      .join("text")
      .attr("class", styles["status-title"])
      .attr("text-anchor", "middle")
      .attr("x", width / 2)
      .attr("y", yChartTitle)
      .text(statusTitle);

    // add chart description
    const foreignObject = gElement
      .selectAll("foreignObject")
      .data(item)
      .join("foreignObject")
      .attr("class", styles["status-description"])
      .attr("x", margin.left)
      .attr("y", yChartDescription)
      .attr("width", w)
      .attr("height", "90");

    const statusDescriptionNode = foreignObject
      .append("xhtml:div")
      .append("xhtml:p")
      .attr("class", styles["chart-object-p"])
      .attr("data-testid", "view-details-text")
      .text(statusDescription);

    if (linkUrl) {
      statusDescriptionNode
        .append("xhtml:a")
        .attr("href", (d) => d.linkUrl)
        .attr("data-testid", "view-details-link")
        .text((d) => ` ${d.linkLabel}`);
    }

    return () => {
      svgElement.selectAll(".chart-description > *").remove();
    };
  }, [data, linkUrl, linkLabel, resize]);
  return (
    <>
      <g className="chart-description"></g>
    </>
  );
}
